// アコーディオン
const acBtnHf = $('.js-accordion-trigger');

acBtnHf.on('click', function () {
	let _e = $(this);
	_e.toggleClass('-open');
	_e.next('.js-accordion-target').slideToggle(250, 'swing').toggleClass('-open');
});
